module.exports = __webpack_public_path__ + "static/media/bbc_news_world-europe-36809083_plot.46a3a5be.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/bbc_news_world-europe-36809083_plot.png
// module id = 362
// module chunks = 0